var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCheckEligibility(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7273 15.9134V14.5497C11.7273 13.8264 11.4399 13.1327 10.9285 12.6212C10.417 12.1098 9.72332 11.8224 9 11.8224H4.22727C3.50396 11.8224 2.81026 12.1098 2.2988 12.6212C1.78734 13.1327 1.5 13.8264 1.5 14.5497V15.9134M12.4091 9.09517L13.7727 10.4588L16.5 7.73153M9.34091 6.3679C9.34091 7.87413 8.11987 9.09517 6.61364 9.09517C5.10741 9.09517 3.88636 7.87413 3.88636 6.3679C3.88636 4.86167 5.10741 3.64062 6.61364 3.64062C8.11987 3.64062 9.34091 4.86167 9.34091 6.3679Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCheckEligibility);
export default __webpack_public_path__ + "static/media/userCheckEligibility.726f287779c2714198616d64cd0cd277.svg";
export { ForwardRef as ReactComponent };